<template>
  <div>
    <list
      ref="refHabilityTypeList"
      sort-by="HabilidadTipoId"
      :refetch-records="fetchHabilityTypes"
      refetch-records-name="habilidadTipos"
      :actions="actions"
      key-field="habilidadTipoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteHabilityType"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refHabilityTypeList = ref(null)
    /* Services */
    const {
      fetchHabilityTypes,
      deleteHabilityType,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.habilityType.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.habilityType.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'HabilidadTipo',
        routeName: 'apps-human-resources-hability-type-edit',
        params: ['habilidadTipoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'HabilidadTipo',
        params: ['habilidadTipoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-hability-type-add',
        label: i18n.t('Routes.HabilityTypeAdd'),
        aclAction: 'create',
        aclResource: 'HabilidadTipo',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refHabilityTypeList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchHabilityTypes,
      deleteHabilityType,
    }
  },
}
</script>
